import { Controller } from '@hotwired/stimulus'

// Simple controller that dispatches a custom event on connect, then removes itself.
// Usage: <template data-controller="dispatch" data-dispatch-event-value="my-event"></template>
export default class extends Controller {
  static values = { event: String }

  connect() {
    if (this.eventValue) {
      window.dispatchEvent(new CustomEvent(this.eventValue))
    }
    this.element.remove()
  }
}
